import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ScheduleAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  // GET_ALL //
  getAllError() {
    const message = {
      body: 'SCHEDULE_GET_ALL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'SCHEDULE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'SCHEDULE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createLeaveOverlapError() {
    const message = {
      body: 'SCHEDULE_CREATE_LEAVE_OVERLAP_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'SCHEDULE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'SCHEDULE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteOneSuccess() {
    const message = {
      body: 'TEMPLATE_SCHEDULE_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteOneError() {
    const message = {
      body: 'TEMPLATE_SCHEDULE_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // APPROVE //
  approveOneSuccess() {
    const message = {
      body: 'TEMPLATE_SCHEDULE_APPROVE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  approveOneError() {
    const message = {
      body: 'TEMPLATE_SCHEDULE_APPROVE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REJECT //
  rejectOneSuccess() {
    const message = {
      body: 'TEMPLATE_SCHEDULE_REJECT_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  rejectOneError() {
    const message = {
      body: 'TEMPLATE_SCHEDULE_REJECT_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET_TEMPLATE_AGENTS //

  getTemplateAgentsError() {
    const message = {
      body: 'SCHEDULE_GET_TEMPLATE_AGENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
}

angular
  .module('bringoz.admin.schedule')
  .service('scheduleAlertsService', ScheduleAlertsService);
